import React, { useEffect } from "react";

import ZipsterMountains from "../../assets/Zipster.png";
import ZipLetterLogo from "../../assets/ZipLetterLogo.png";

import AOS from "aos";
import "aos/dist/aos.css";

const Zipster = (props) => {
  useEffect(() => {
    AOS.init({
      duration: 3000,
    });
  }, []);

  return (
    <div id="Zipster">
      <h2 data-aos={"flip-left"} className="Zipster__header">
        Want to become a{" "}
        <span>
          <img className="Zipster__zipLogo" src={ZipLetterLogo} alt="" /> ipster{" "}
        </span>
        at Johns Hopkins?
      </h2>
    
      <a
        target="_blank"
        href="mailto:ziplyne@lists.johnshopkins.edu?subject=Interested in Becoming a Zipster at Johns Hopkins"
      >
        <div data-aos={"flip-left"} className="Zipster__button">
          Click to become a Zipster!
        </div>
      </a>
      <img
        data-aos={"fade-left"}
        className="Zipster__mountains"
        src={ZipsterMountains}
        alt=""
      />
      <div data-aos={"fade-right"} className="Zipster__Sierra"> 
        <span>Sierra</span><br /> <span style={{fontWeight: "normal"}}>Advanced Track</span>
      </div>
      <div data-aos={"fade-right"} className="Zipster__Tibesti">
        <span>Tibesti</span><br /> <span style={{fontWeight: "normal"}}>Medium Track</span>
      </div>
      <div data-aos={"fade-right"} className="Zipster__Olympus">
        <span>Olympus</span><br /> <span style={{fontWeight: "normal"}}>Basic Track</span>
      </div>
      <div
        onClick={() =>
          window.open(
            "http://help.ziplyne.com/en/articles/5013599-zipster-tracks-and-what-they-mean"
          )
        }
        data-aos={"fade-right"}
        className="Zipster__buttonLearnMore"
      >
        Learn More
      </div>
    </div>
  );
};

export default Zipster;
